"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _6CXWEW5Ocjs = require('../__chunks/6CXWEW5O.cjs');
require('../__chunks/LH55DG7M.cjs');
require('../__chunks/XRATBFDX.cjs');


var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-group.tsx
var _dom = require('@ariakit/core/utils/dom');
var _misc = require('@ariakit/core/utils/misc');
var TagName = "div";
var useComboboxGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useComboboxGroup2({ store, ...props }) {
    const context = _EV33XSIBcjs.useComboboxScopedContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
    const popupRole = _dom.getPopupRole.call(void 0, contentElement);
    if (popupRole === "grid") {
      props = { role: "rowgroup", ...props };
    }
    props = _6CXWEW5Ocjs.useCompositeGroup.call(void 0, { store, ...props });
    return props;
  }
);
var ComboboxGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxGroup2(props) {
  const htmlProps = useComboboxGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ComboboxGroup = ComboboxGroup; exports.useComboboxGroup = useComboboxGroup;
